import React from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { Route, Switch } from "react-router-dom";

import Navigation from "components/Navbars/Navigation.js";
import { Container } from "reactstrap";

// routes
import routes from "routes.js";

// helpers
import { getSessionCookie } from "helpers/cookies.js";

class Auth extends React.Component {
  constructor(props) {
    super(props);    
    this.validaPermissaoAcesso();
  }

  validaPermissaoAcesso = () => {    
    let session = getSessionCookie();  
    if (session == null && this.props.location.pathname.indexOf('/auth/login') == -1)
    {
      this.props.history.push('/auth/login');
      return;
    }    
  }
  
  render() {
    return (
      <div className="content-login">
        <div className="img-bg"></div>
        <Navigation />
        <Container className="margin-auth">
          <Switch>
            {routes != null && routes.filter(f => f.layout == "/auth").map((prop, key) => {
              return (
                <Route
                  path={prop.layout + prop.path}
                  component={prop.component}
                  key={key}
                />
              );
            })}
          </Switch>
        </Container>
      </div>
    );
  }
}

export default Auth;
